<template>
  <div class="container p-lg-0">
    <div v-bind:data-kt-indicator="loading ? 'on' : 'off'">
      <span class="indicator-progress">
        Aguarde, carregando...
        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
      </span>
    </div>
    <div
      v-if="this.errosGerais.Message && !loading"
      class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6 me-lg-10"
      ref="errosGerais"
    >
      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
        <inline-svg src="media/icons/duotune/general/gen044.svg" />
      </span>
      <div class="d-flex flex-stack flex-grow-1">
        <div class="fw-bold">
          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
          <div class="fs-6 text-gray-600">
            {{ this.errosGerais.Message }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading" class="d-flex flex-column flex-lg-row">
      <div
        v-if="this.consultarTipoUsuario"
        class="d-flex flex-column mb-7 me-lg-10 min-w-lg-300px min-w-xl-375px"
      >
        <div class="card card-flush py-5">
          <div class="card-header">
            <div class="card-title">
              <img
                src="media/icons/duotune/communication/com014.svg"
                class="me-2"
              />
              <h2>Grupo de Restrições</h2>
            </div>
          </div>
          <div class="card-body pt-0">
            <div
              class="d-flex align-items-center position-relative my-1"
              v-bind:data-kt-indicator="loadingTipoUsuario ? 'on' : 'off'"
            >
              <span class="svg-icon svg-icon-1 position-absolute ms-6">
                <inline-svg src="media/icons/duotune/general/gen004.svg" />
              </span>
              <input
                id="txtPesquisarGrupo"
                type="text"
                v-model="pesquisaTipoUsuario"
                @input="onSearchTipoUsuario($event.target.value)"
                class="form-control form-control-solid ps-15"
                placeholder="Pesquisar Grupo"
              />
              <span class="indicator-progress position-absolute end-0 me-6">
                <span
                  class="spinner-border align-middle"
                  style="width: 1.5rem; height: 1.5rem"
                ></span>
              </span>
            </div>
            <div
              class="menu menu-rounded menu-column menu-active-bg menu-hover-bg menu-title-gray-700 fs-5 fw-bold mt-5"
              data-kt-menu="true"
              :class="[loadingTipoUsuario && 'overlay overlay-block']"
            >
              <div
                class="menu-item"
                v-for="(tipo, i) in tipoUsuario"
                v-bind:key="i"
              >
                <a
                  class="menu-link border-3 border-start border-info py-0 ps-0"
                  :class="[tipo.id === idTipoUsuario && 'active']"
                >
                  <span
                    class="menu-title ps-4 py-4 m-0"
                    @click="selecionarTipoUsuario(tipo.id)"
                    >{{ tipo.tipo }}</span
                  >
                  <button
                    v-if="this.editarTipoUsuario"
                    type="button"
                    class="btn btn-sm btn-light-info py-2 ps-2 pe-0 me-2"
                    @click="editarGrupo(tipo.id)"
                  >
                    <span class="svg-icon svg-icon-1">
                      <inline-svg src="media/icons/duotune/art/art005.svg"
                    /></span>
                  </button>
                  <button
                    v-if="this.excluirTipoUsuario"
                    type="button"
                    class="btn btn-sm btn-light-danger p-3"
                    @click="excluirGrupo(tipo.id)"
                  >
                    <i class="la la-trash-o p-0 fs-2"></i>
                  </button>
                </a>
              </div>
              <div
                v-if="tipoUsuario.length === 0"
                class="d-flex align-items-center py-3 px-2 ps-lg-10 pe-lg-4"
              >
                <span class="bullet bullet-dot"></span>
                <span class="ps-4">Nenhum grupo foi encontrado!</span>
              </div>
              <div
                v-if="loadingTipoUsuario"
                class="overlay-layer card-rounded bg-dark bg-opacity-5 p-5"
              >
                <div class="spinner-border text-primary" role="status"></div>
                <span class="ms-2">Aguarde, carregando...</span>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-5">
              <button
                v-if="this.adicionarTipoUsuario"
                type="button"
                class="btn btn-sm btn-light-info py-3"
                @click="adicionarGrupo()"
              >
                <span class="svg-icon svg-icon-1">
                  <inline-svg
                    src="media/icons/duotune/general/gen041.svg" /></span
                >Adicionar Grupo
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="d-flex flex-column flex-row-fluid mb-7 me-lg-10 min-w-lg-375px"
      >
        <div class="card card-flush py-5">
          <div class="card-header">
            <div class="card-title">
              <img src="media/icons/duotune/general/gen051.svg" class="me-2" />
              <h2>Restrições Administrativas</h2>
            </div>
          </div>
          <div v-if="idTipoUsuario !== 0" class="card-body pt-0">
            <div
              ref="pesquisaRestricao"
              class="d-flex align-items-center position-relative my-1"
              v-bind:data-kt-indicator="loadingRestricao ? 'on' : 'off'"
            >
              <span class="svg-icon svg-icon-1 position-absolute ms-6">
                <inline-svg src="media/icons/duotune/general/gen004.svg" />
              </span>
              <input
                type="text"
                v-model="pesquisaRestricao"
                @input="onSearchRestricao($event.target.value)"
                class="form-control form-control-solid ps-15"
                placeholder="Pesquisar Restrições"
              />
              <span class="indicator-progress position-absolute end-0 me-6">
                <span
                  class="spinner-border align-middle"
                  style="width: 1.5rem; height: 1.5rem"
                ></span>
              </span>
            </div>
            <div
              class="menu menu-rounded menu-column menu-active-bg menu-hover-bg menu-title-gray-700 fs-5 fw-bold mt-5"
              data-kt-menu="true"
              :class="[loadingRestricao && 'overlay overlay-block']"
            >
              <div
                class="menu-item menu-accordion"
                data-kt-menu-trigger="click"
                v-for="(modulo, i) in restricaoPadrao"
                v-bind:key="i"
              >
                <a class="menu-link border-3 border-start border-info">
                  <span class="menu-title">{{ i }}</span>
                  <span class="menu-badge fs-7 fw-bold text-muted pe-2">{{
                    verificarPermissaoAtiva(modulo) + "/" + modulo.length
                  }}</span>
                  <span class="menu-arrow"></span>
                </a>
                <div class="menu-sub menu-sub-accordion py-3">
                  <div
                    class="menu-item"
                    v-for="(restricao, ir) in modulo"
                    v-bind:key="ir"
                  >
                    <a
                      class="menu-link py-3 px-2 ps-lg-8 pe-lg-4"
                      @click="alterarRestricao(i, ir)"
                    >
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">{{ restricao.descricao }}</span>
                      <span
                        v-if="restricao.id"
                        class="badge badge-light-success ms-2"
                        >Permitir</span
                      >
                      <span v-else class="badge badge-light-danger ms-2"
                        >Negado</span
                      >
                    </a>
                  </div>
                </div>
              </div>
              <div
                v-if="restricaoPadrao.length === 0"
                class="d-flex align-items-center py-3 px-2 ps-lg-10 pe-lg-4"
              >
                <span class="bullet bullet-dot"></span>
                <span class="ps-4">Nenhuma restrição foi encontrada!</span>
              </div>
              <div
                v-if="loadingRestricao"
                class="overlay-layer card-rounded bg-dark bg-opacity-5 p-5"
              >
                <div class="spinner-border text-primary" role="status"></div>
                <span class="ms-2">Aguarde, carregando...</span>
              </div>
            </div>
          </div>
          <div
            v-else
            class="notice d-flex bg-light-info rounded border-info border border-dashed mx-10 mb-10 p-6"
          >
            <span class="svg-icon svg-icon-2tx svg-icon-info me-4">
              <inline-svg src="media/icons/duotune/general/gen044.svg" />
            </span>
            <div class="d-flex flex-stack flex-grow-1">
              <div class="fw-bold">
                <h4 class="text-gray-800 fw-bolder">
                  Selecione um Grupo de usuário
                </h4>
                <div class="fs-6 text-gray-600">
                  {{ this.errosGerais.Message }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <TipoUsuariosModal
    v-if="exibirTipoUsuarios"
    :idTipoUsuario="idEditarTipoUsuario"
    @exibirModalTipoUsuario="modalTipoUsuarios"
    @atualizarTipoUsuario="atualizarTipoUsuario"
  ></TipoUsuariosModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { MenuComponent } from "@/assets/ts/components";
import TipoUsuariosModal from "../tipousuarios/TipoUsuariosModal.vue";
import { mapState } from "vuex";
import _ from "lodash";
import { useToast } from "vue-toastification";
const toast = useToast();
import { getOrCreateInstanceModal } from "@/core/helpers/dom";

export default {
  components: { TipoUsuariosModal },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    async atualizarTipoUsuario() {
      this.loadingTipoUsuario = true;
      await this.carregarTipoUsuario();
    },
    adicionarGrupo() {
      this.idTipoUsuario = 0;
      this.idEditarTipoUsuario = 0;
      this.modalTipoUsuarios(true);
    },
    editarGrupo(id) {
      this.idTipoUsuario = 0;
      this.idEditarTipoUsuario = id;
      this.modalTipoUsuarios(true);
    },
    async excluirGrupo(id) {
      this.idTipoUsuario = 0;
      await this.$swal.showQuestionAlert(
        "Deseja remover o registro?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.loadingTipoUsuario = true;
            await this.deletarRestricoes(id);
            try {
              var retDelete = await this.$store.dispatch(
                "tipoUsuario/deleteTipoUsuario",
                id
              );
              if (retDelete.Success === true) {
                toast.success("Grupo excluído com sucesso!", { timeout: 2000 });
                await this.carregarTipoUsuario();
              }
            } catch (error) {
              await this.$swal.showErrorAlert(error.Message);
            }
          }
        }
      );
      this.loadingTipoUsuario = false;
    },
    async deletarRestricoes(id) {
      try {
        var retOdata = await this.$store.dispatch(
          "restricao/getRestricaoOData",
          "?$select=id,permissao,modulo,descricao,regra,id_tipo_usuario&$orderby=modulo asc" +
            "&$filter=id_tipo_usuario eq " +
            id
        );
        if (retOdata.value !== null && retOdata.value.length > 0) {
          var restricaoGrupo = retOdata.value;

          for (var i = 0; i < restricaoGrupo.length; i++) {
            try {
              await this.$store.dispatch(
                "restricao/deleteRestricao",
                restricaoGrupo[i].id
              );
            } catch (error) {
              this.errosGerais = error;
            }
          }
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },
    modalTipoUsuarios(exibir) {
      this.exibirTipoUsuarios = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_tipo_usuarios_editar",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_tipo_usuarios_editar");
          },
          /*close*/ () => {
            this.modalTipoUsuarios(false);
          }
        );
      }
    },
    async selecionarTipoUsuario(id) {
      this.idTipoUsuario = id;
      await this.carregarRestricaoPadrao();
    },
    async onSearchTipoUsuario(pesquisa) {
      this.loadingTipoUsuario = true;
      if (pesquisa !== "") {
        this.filtroTipoUsuario = "&$filter=contains(tipo, '" + pesquisa + "') ";
      } else {
        this.filtroTipoUsuario = "";
      }

      clearTimeout(this.timeOutTipoUsuario);
      this.timeOutTipoUsuario = setTimeout(await this.carregarTipoUsuario, 500);
    },
    async carregarTipoUsuario() {
      this.errosGerais = {};
      this.idTipoUsuario = 0;
      try {
        var retOdata = await this.$store.dispatch(
          "tipoUsuario/getTipoUsuarioOData",
          "?$select=id,tipo&$orderby=tipo asc" + this.filtroTipoUsuario
        );
        if (retOdata.value !== null && retOdata.value.length > 0) {
          this.tipoUsuario = retOdata.value;
        } else {
          this.tipoUsuario = [];
        }
      } catch (error) {
        this.errosGerais = error;
      }
      this.loadingTipoUsuario = false;
    },
    async onSearchRestricao(pesquisa) {
      this.loadingRestricao = true;
      if (pesquisa !== "") {
        this.filtroRestricao =
          "&$filter=contains(modulo, '" +
          pesquisa +
          "') or contains(descricao, '" +
          pesquisa +
          "') ";
      } else {
        this.filtroRestricao = "";
      }

      clearTimeout(this.timeOutRestricao);
      this.timeOutRestricao = setTimeout(
        await this.carregarRestricaoPadrao,
        500
      );
    },
    async carregarRestricaoPadrao() {
      this.loadingRestricao = true;
      this.errosGerais = {};
      if (this.idTipoUsuario !== 0) {
        try {
          var retOdata = await this.$store.dispatch(
            "restricaoPadrao/getRestricaoPadraoOData",
            "?$select=permissao,modulo,descricao,regra&$orderby=modulo asc" +
              this.filtroRestricao
          );
          if (retOdata.value !== null && retOdata.value.length > 0) {
            await this.carregarRestricao(retOdata.value);
            setTimeout(MenuComponent.reinitialization, 1000);
            this.scroll("pesquisaRestricao");
          } else {
            this.restricaoPadrao = [];
          }
        } catch (error) {
          this.errosGerais = error;
        }
      }
      this.loadingRestricao = false;
    },
    async carregarRestricao(restricoes) {
      try {
        var retOdata = await this.$store.dispatch(
          "restricao/getRestricaoOData",
          "?$select=id,permissao,modulo,descricao,regra,id_tipo_usuario&$orderby=modulo asc" +
            "&$filter=id_tipo_usuario eq " +
            this.idTipoUsuario
        );
        if (retOdata.value !== null && retOdata.value.length > 0) {
          this.restricaoGrupo = retOdata.value;

          for (var i = 0; i < this.restricaoGrupo.length; i++) {
            for (var y = 0; y < restricoes.length; y++) {
              if (this.restricaoGrupo[i].regra === restricoes[y].regra) {
                restricoes[y].id = this.restricaoGrupo[i].id;
                restricoes[y].id_tipo_usuario =
                  this.restricaoGrupo[i].id_tipo_usuario;
              }
            }
          }
        } else {
          this.restricaoGrupo = [];
        }
      } catch (error) {
        this.errosGerais = error;
      }
      this.restricaoPadrao = _.groupBy(restricoes, "modulo");
    },
    async alterarRestricao(i, ir) {
      var restricao = this.restricaoPadrao[i][ir];
      await this.$swal.showQuestionAlert(
        "Deseja " + (restricao.id ? "negar" : "permitir") + " esta restrição?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.loadingRestricao = true;
            if (restricao.id === undefined) {
              if (this.adicionarRestricao === false) {
                await this.$swal.showErrorAlert(
                  "Usuário não tem permissão para permitir esta restrição!"
                );
              } else {
                try {
                  restricao.id_tipo_usuario = this.idTipoUsuario;
                  var ret = await this.$store.dispatch(
                    "restricao/postRestricao",
                    restricao
                  );
                  if (ret.Success === true) {
                    restricao.id = ret.Data.id;
                  }
                } catch (error) {
                  this.errosGerais = error;
                }
              }
            } else {
              if (this.excluirRestricao === false) {
                await this.$swal.showErrorAlert(
                  "Usuário não tem permissão para negar esta restrição!"
                );
              } else {
                try {
                  var retDelete = await this.$store.dispatch(
                    "restricao/deleteRestricao",
                    restricao.id
                  );
                  if (retDelete.Success === true) {
                    restricao.id = undefined;
                    restricao.id_tipo_usuario = undefined;
                  }
                } catch (error) {
                  this.errosGerais = error;
                }
              }
            }
          }
          this.loadingRestricao = false;
        }
      );
    },
    verificarPermissaoAtiva(modulo) {
      var qtd = 0;
      for (var i in modulo) {
        if (modulo[i].id !== undefined) {
          qtd++;
        }
      }
      return qtd;
    },
    scroll(scrollRef) {
      let el = this.$refs[scrollRef];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async verificarRestricoes() {
      if (this.user.User.TipoUsuario.Restricao != null) {
        this.user.User.TipoUsuario.Restricao.find((element) => {
          if (element.regra === "Permitir.Restricao.Incluir") {
            this.adicionarRestricao = true;
          }
          if (element.regra === "Permitir.Restricao.Excluir") {
            this.excluirRestricao = true;
          }

          if (element.regra === "Permitir.TipoUsuario.Consultar") {
            this.consultarTipoUsuario = true;
          }
          if (element.regra === "Permitir.TipoUsuario.Incluir") {
            this.adicionarTipoUsuario = true;
          }
          if (element.regra === "Permitir.TipoUsuario.Alterar") {
            this.editarTipoUsuario = true;
          }
          if (element.regra === "Permitir.TipoUsuario.Excluir") {
            this.excluirTipoUsuario = true;
          }
        });
      }
    },
  },
  async mounted() {
    this.loading = true;
    await this.verificarRestricoes();
    await this.carregarTipoUsuario();
    await this.carregarRestricaoPadrao();
    this.loading = false;
    if (this.consultarTipoUsuario) {
      setTimeout(() => {
        this.nextFocus("txtPesquisarGrupo");
      }, 800);
    } else {
      await this.selecionarTipoUsuario(this.user.User.TipoUsuario.id);
    }
  },
  data() {
    return {
      exibirTipoUsuarios: false,
      loading: false,
      loadingTipoUsuario: false,
      loadingRestricao: false,
      errosGerais: {},
      adicionarRestricao: false,
      excluirRestricao: false,
      consultarTipoUsuario: false,
      adicionarTipoUsuario: false,
      editarTipoUsuario: false,
      excluirTipoUsuario: false,
      idTipoUsuario: 0,
      idEditarTipoUsuario: 0,
      pesquisaTipoUsuario: "",
      filtroTipoUsuario: "",
      timeOutTipoUsuario: null,
      pesquisaRestricao: "",
      filtroRestricao: "",
      timeOutRestricao: null,
      tipoUsuario: [],
      restricaoPadrao: [],
      restricaoGrupo: [],
    };
  },
};
</script>

<style></style>
